<template>
  <div class="page">
    <div class="page-heading">
      <h1>
        Seller Listing: <span>{{ listing.listing_id }}</span>
      </h1>
      <h2>
        {{ postDate }} Succession Resource Group M&amp;A Alert
      </h2>
    </div>

    <div class="page-hero" :style="`background-image: linear-gradient( 30deg, rgba(50,50,50, .5) 1%, rgba(255,255,255, .0) ), url('${listing.img}')`">
      <div v-if="listing.status == 2" class="page-hero-info">
        <span>{{ listing.type_name }} Advisor</span>
        <span>{{ listing.status_name }}</span>
      </div>
      <div v-else-if="[1,3,4].includes(listing.status)" class="page-hero-info">
        <span>{{ listing.location | location }}</span>
        <span>{{ listing.type_name }} Advisor</span>
      </div>
    </div>

    <div class="page-info-boxes">
      <dl v-if="listing.status == 2">
        <dd>{{ listing.location | location }}</dd>
      </dl>
      <dl v-else-if="[1,3.4].includes(listing.status)">
        <dd >{{ listing.revenue | currency }}</dd>
        <dt>Revenue</dt>
        <dt>(<span class="text-lowercase">as of</span> <span class="text-capitalize">{{listing.revenue_t12_asof_date}}</span>)</dt>
      </dl>
      <dl>
        <dd>{{ listing.aum | currency }}</dd>
        <dt>AUM</dt>
      </dl>
      <dl>
        <dd>{{ listing.revenue_percent_recurring }}%</dd>
        <dt>Recurring Revenue</dt>
      </dl>
    </div>

    <div class="page-container">
      <div class="page-col">
        <div class="next-steps-container">
          <h2>Next Steps</h2>

          <div class="group">
            <a
              :href="`${myCompassUrl}/module_questionnaire/buyer`"
              class="btn btn-blue">
              Submit Your Buyer Profile
            </a>
          </div>

          <div class="divider">
            <span>OR</span>
          </div>

          <div class="group">
            <a
              :href="`${myCompassUrl}/buyer_listings/`"
              class="btn btn-blue">
              <label>Already submitted your buyer profile?</label>
              <span>Indicate Your Interest</span>
            </a>
          </div>
        </div>
      </div>

      <div class="page-col"></div>

      <div class="page-col">
        <div class="text-justify text--secondary" v-html="listing.description"></div>
      </div>
    </div>

    <div class="branding">
      <img class="page-img-logo" src="./assets/logo.png" />

      <div class="branding-copyright">
        <h5>Guidance.   Experience.   Trust.</h5>
        <div class="copyright">
          <span>Copyright © {{copyright_year}} Succession Resource Group</span>
          <span><a href="tel:503-427-9910">503-427-9910</a></span>
          <span>
            <a href="mailto:info@successionresourcegroup.com">
              info@successionresourcegroup.com
            </a>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import appUrls from '../../helpers/environment';
  import dateformat from 'dateformat'

  import BottomColorBar from './partials/BottomColorBar'

  export default {
    name: 'PdfPage1',
    components: {
      BottomColorBar,
    },
    props: {
      listing: {
        type: Object,
        default: () => ({}),
      }
    },

    data () {
      return {
        myCompassUrl: appUrls.mycompass
      }
    },

    computed: {
      postDate () {
        const posted = this.listing.post_date
        return dateformat(posted || (new Date()), 'yyyy')
      },
      copyright_year() {
        return new Date().getFullYear().toString();
      }
    }
  }
</script>

<style scoped>
  .pdf-content .page {
    background-image: none;
    padding-bottom: 10px;
  }

  .page-heading {
    height: 140px;
    width: 750px;
    margin: 0 auto;
    padding: 20px;

    text-align: center;
  }

  .page-heading h1 {
    color: #0096A6;
  }

  .page-heading h1 span {
    color: #E95542;
  }

  .page-heading h2 {
    font-size: 18pt;
  }

  .page-hero {
    position: relative;
    height: 300pt;
    width: 100%;

    background-size: cover;
    background-position: center;
  }

  .page-hero-info {
    position: absolute;
    bottom: 30px;
    left: 50px;

    display: flex;
    flex-direction: column;

    color: white;
    /* text-shadow: 1px 1px 7px #666666; */
  }

  .page-hero-info span:nth-child(1) {
    font-family: "SansationBold", sans-serif;
    font-size: 28pt;
    line-height: 30pt;
  }

  .page-hero-info span:nth-child(2) {
    font-family: "Sansation", sans-serif;
    font-size: 20pt;
    line-height: 22pt;
  }


  .page-info-boxes {
    width: 100%;
    height: 60pt;

    display: flex;
    justify-content: stretch;
  }

  .page-info-boxes dl {
    flex: 1 0 33%;
    padding: 5px 10px;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    color: white;
    text-align: center;
  }

  .page-info-boxes dl:nth-child(1) {
    background-color: #E95542;
  }

  .page-info-boxes dl:nth-child(2) {
    background-color: #99CC33;
  }

  .page-info-boxes dl:nth-child(3) {
    background-color: #1F8A92;
  }

  .page-info-boxes dt {
    font-family: "Sansation", sans-serif;
    font-size: 12pt;
    text-transform: uppercase;
  }

  .page-info-boxes dd {
    font-family: "SansationBold", sans-serif;
    font-size: 18pt;
    line-height: 20pt;
  }

  .page-container {
    flex-grow: 1;
    flex-shrink: 1;
    display: flex;
    overflow: hidden;
  }

  .page-container .page-col {
    position: relative;
    height: 100%;
  }

  .page-container .page-col:nth-child(1) {
    flex-grow: 1;
  }

  .page-container .page-col:nth-child(2) {
    flex: 0 0 4px;
  }

  .page-container .page-col:nth-child(2)::after {
    content: '';
    position: absolute;
    top: 20px;
    bottom: 20px;
    left: 0;
    right: 0;

    background-color: #E95542;
  }

  .page-container .page-col:nth-child(3) {
    flex: 0 0 370px;
    padding: 40px 20px;
  }

  .page-container .page-col >>> p {
    font-family: "Avenir", sans-serif;
    font-size: 12.5pt;
  }

  .next-steps-container {
    padding: 20px 30px;

    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .next-steps-container h2 {
    align-self: flex-start;
    margin-bottom: 20px;
  }

  .next-steps-container .group {
    flex: 1 1 50%;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .next-steps-container .group .btn {
    height: 50px;
    width: 280px;
    margin-bottom: 20px;
    padding: 0 10px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .next-steps-container .btn {
    font-size: 12pt;
    line-height: 12pt;
  }

  .next-steps-container .btn label {
    margin-bottom: 5px;

    display: block;
    font-family: "Sansation", sans-serif;
    font-size: 8pt;
    line-height: 8pt;

    cursor: pointer;
  }

  .next-steps-container .divider {
    position: relative;
    margin-bottom: 20px;

    border-radius: 50%;
    background-color: #0093A333;
    width: 45px;
    height: 45px;

    display: flex;
    justify-content: center;
    align-items: center;
  }

  .next-steps-container .divider::before {
    content: '';
    position: absolute;
    left: -35px;
    top: 50%;

    height: 2px;
    width: 30px;

    background-color: #B2DEE2;
    border-radius: 1px;
  }

  .next-steps-container .divider::after {
    content: '';
    position: absolute;
    right: -35px;
    top: 50%;

    height: 2px;
    width: 30px;

    background-color: #B2DEE2;
    border-radius: 1px;
  }

  .next-steps-container .divider span {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 40px;
    height: 40px;

    border-radius: 50%;
    background-color: #D9EFF1;
    border: 2px solid #9AD5DA;

    color: #0093A3;
    font-family: "SansationBold", sans-serif;
    font-size: 12pt;
  }

  .branding {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    width: 700px;
    margin: 0 auto;
  }

  .branding-copyright {
    padding-bottom: 10px;
  }

  .pdf-content .page .copyright {
    margin: 0;
  }

  .pdf-content .page .copyright span,
  .pdf-content .page .copyright a {
    font-size: 7pt;
  }

  .page-img-logo {
    display: block;
    width: 180px;
  }
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details-as-pdf/PdfPage1.vue